import Image from "next/image";

interface MubinsoHeroProps {
  companyName: string;
  mainImage: string | null;
}

export const MubinsoHero = ({ companyName, mainImage }: MubinsoHeroProps) => {
  return (
    <>
      <div className="mb-banner">
        장례비용, 무빈소 장례, 장례식장 정보를 안내드리는 고이장례연구소입니다.
      </div>

      <section className="mb-hero" aria-labelledby="mb-page-title">
        <div className="mb-hero__head">
          <span className="mb-hero__eyebrow">무빈소 장례의 모든 것</span>
          <h1 id="mb-page-title" className="mb-hero__title">
            {companyName}
            <br />
            무빈소 장례
          </h1>
        </div>

        <p className="mb-hero__lede">
          비용부터 절차까지 모두 투명하게 정리해드립니다.
        </p>

        <p className="mb-hero__note">
          형식은 간소해져도, 마음의 깊이는 다르지 않아요.
          <br />
          정성스러운 마음 그대로 무빈소에 대해 알려드릴게요.
        </p>
      </section>

      {mainImage && (
        <div className="mb-hero__image">
          {/* e하늘 원본을 그대로 쓴다. RegionParlorList 와 같은 unoptimized 정책 */}
          <Image
            src={mainImage}
            alt={`${companyName} 전경`}
            width={880}
            height={240}
            sizes="(max-width: 880px) 100vw, 880px"
            unoptimized
          />
        </div>
      )}
    </>
  );
};

interface MubinsoHeroSimpleProps {
  companyName: string;
  address: string;
  mainImage: string | null;
}

/**
 * B 템플릿 Hero. 띠지, eyebrow, 소개 문구를 빼고 이름, 주소, 사진만 세로로 둔다.
 * h1 은 A 와 같은 "{이름} 무빈소 장례" 로 둔다. 무빈소 비용은 무빈소 장례와 다른 주제라 페이지 주제를 바꾸지 않는다.
 * 독사운드 강화 템플릿의 stack Hero 와 같은 구성이다. 고정 문구가 없어 A 와 겹치지 않는다.
 */
export const MubinsoHeroSimple = ({
  companyName,
  address,
  mainImage,
}: MubinsoHeroSimpleProps) => {
  return (
    <section className="mb-hero-simple" aria-labelledby="mb-page-title">
      <h1 id="mb-page-title" className="mb-hero-simple__title">
        {`${companyName} 무빈소 장례`}
      </h1>
      {address && <p className="mb-hero-simple__address">{address}</p>}
      {mainImage && (
        <div className="mb-hero-simple__image">
          <Image
            src={mainImage}
            alt={`${companyName} 전경`}
            width={880}
            height={240}
            sizes="(max-width: 880px) 100vw, 880px"
            unoptimized
          />
        </div>
      )}
    </section>
  );
};
